import React from 'react'
import styles from './styles.module.scss'

export function CookiesPolicyRender() {
  return (
    <div className={styles.termsTemplate}>
      <p className={styles.lastUpdate}>
        Última atualização: 12 de setembro de 2025
      </p>

      <div className={styles.space}>
        <p>
          A <strong>RESALE TECNOLOGIA S.A. (“RESALE”)</strong>, CNPJ nº
          21.129.873/0001-79, utiliza cookies e tecnologias semelhantes para
          melhorar a experiência do usuário em seus ambientes digitais,
          incluindo:
        </p>
        <ul>
          <li>site institucional (www.resale.com.br);</li>
          <li>a Plataforma Pagimovel®;</li>
          <li>os portais parceiros em modelo white label. </li>
        </ul>
        <p>
          Esta Política explica o que são cookies, como os usamos e como você
          pode gerenciar suas preferências.
        </p>
      </div>

      <div>
        <div className={styles.space}>
          <h2 className={styles.spaceTop}>1. O QUE SÃO COOKIES?</h2>
          <p>
            Cookies são pequenos arquivos de texto armazenados no seu navegador
            quando você visita um site. Eles permitem reconhecer o seu
            dispositivo, lembrar preferências e melhorar a navegação.
            Tecnologias semelhantes (como pixels, tags e local storage) podem
            ser usadas para os mesmos fins.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>
            2. QUE TIPOS DE COOKIES UTILIZAMOS?
          </h2>

          <p className={styles.underline}>Cookies estritamente necessários</p>
          <ul>
            <li>
              Essenciais para o funcionamento da Plataforma, permitindo
              navegação, autenticação e segurança. Sem eles, serviços básicos
              podem não funcionar.
            </li>
          </ul>

          <p className={styles.underline}>Cookies de desempenho</p>
          <ul>
            <li>
              Coletam informações anônimas sobre como os usuários utilizam o
              site e a Plataforma, ajudando a melhorar usabilidade, velocidade e
              experiência.
            </li>
          </ul>

          <p className={styles.underline}>Cookies de funcionalidade</p>
          <ul>
            <li>
              Permitem que a Plataforma lembre preferências (ex.: idioma,
              região, dados de login), oferecendo navegação mais personalizada.
            </li>
          </ul>

          <p className={styles.underline}>Cookies de publicidade e marketing</p>
          <ul>
            <li>
              Usados para oferecer anúncios relevantes, dentro e fora da
              Plataforma, com base nos seus interesses e navegação.
            </li>
          </ul>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>3. COMO USAMOS COOKIES?</h2>

          <p>Utilizamos cookies para:</p>
          <ol type="a">
            <li>manter você autenticado na Plataforma;</li>
            <li>lembrar preferências e configurações;</li>
            <li>analisar tráfego, estatísticas e desempenho;</li>
            <li>melhorar produtos e serviços;</li>
            <li>oferecer conteúdos e anúncios personalizados.</li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>4. GESTÃO DE COOKIES</h2>

          <p>
            Você pode controlar e/ou excluir cookies nas configurações do seu
            navegador. No entanto, ao desativar alguns cookies, certas
            funcionalidades da Plataforma podem ser prejudicadas. Orientações
            para gerenciamento estão disponíveis nos navegadores:
          </p>

          <ol type="a">
            <li>Chrome: support.google.com/chrome</li>
            <li>Firefox: support.mozilla.org</li>
            <li>Safari: support.apple.com</li>
            <li>Edge: support.microsoft.com</li>
          </ol>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>5. CONSENTIMENTO</h2>

          <p>
            Ao acessar o site, a Plataforma ou portais parceiros, você pode
            gerenciar suas preferências de cookies em nosso banner de
            consentimento. Para cookies de marketing, solicitamos o seu
            consentimento prévio e específico.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>6. ALTERAÇÕES DESTA POLÍTICA </h2>

          <p>
            Esta Política poderá ser atualizada para refletir mudanças legais ou
            operacionais. A nova versão será publicada com data de atualização.
          </p>
        </div>

        <div className={styles.space}>
          <h2 className={styles.spaceTop}>7. CANAL DE CONTATO (DPO)</h2>

          <p>
            Encarregada (DPO):{' '}
            <a href="mailto:dpo@resale.com.br">dpo@resale.com.br</a>
          </p>
        </div>
      </div>

      <p className={styles.version}>DOR034 - v3.0 - 20250912</p>
    </div>
  )
}
